// extracted by mini-css-extract-plugin
export default {"MobileBanner":"MobileBanner_MobileBanner__yeLtW","Text":"MobileBanner_Text__9Icli","Image":"MobileBanner_Image__CGFS0"};